import React from "react";

// Artisan Guild Infra mark: three stacked upward chevrons
export function AgiLogo({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      className={className}
      aria-label="Artisan Guild Infra"
    >
      <defs>
        <linearGradient id="agiGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#334155" />
          <stop offset="100%" stopColor="#0f172a" />
        </linearGradient>
      </defs>
      <path d="M50 8 L92 40 L74 40 L50 22 L26 40 L8 40 Z" fill="url(#agiGrad)" />
      <path d="M50 34 L86 60 L70 60 L50 46 L30 60 L14 60 Z" fill="url(#agiGrad)" opacity="0.85" />
      <path d="M50 60 L80 82 L66 82 L50 70 L34 82 L20 82 Z" fill="url(#agiGrad)" opacity="0.7" />
    </svg>
  );
}
